var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,0.9H23.1C7.6,0.9,0.9,7.6,0.9,23.1v17.8c0,4.9,0.7,9,2.1,12.2c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0 c3.1,6.6,9.5,9.6,19.9,9.6h17.8c15.5,0,22.1-6.6,22.1-22.1V23.1C63.1,7.6,56.4,0.9,40.9,0.9z M3.6,23.1C3.6,8.9,8.9,3.6,23.1,3.6 h17.8c14.2,0,19.5,5.3,19.5,19.5v11.7l-2.6-2.3c-2.8-2.4-7.3-2.4-10.1,0L35.3,43.1c-1.8,1.6-4.8,1.6-6.6,0l-1-0.9 c-2.6-2.2-6.6-2.4-9.5-0.5L4.9,50.6C4,48,3.6,44.8,3.6,40.9V23.1z M40.9,60.4H23.1c-9,0-14.4-2.1-17.1-7.2l13.7-9.2 c1.8-1.2,4.6-1.1,6.2,0.3l1,0.9c2.8,2.4,7.3,2.4,10.1,0l12.4-10.6c1.8-1.6,4.8-1.6,6.6,0l4.4,3.8v2.7 C60.4,55.1,55.1,60.4,40.9,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,27.4c4,0,7.3-3.3,7.3-7.3s-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3S19.1,27.4,23.1,27.4z M23.1,15.5 c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6S20.5,15.5,23.1,15.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.1d5c968e7914b2d1be249829fdc37bda.svg";
export { ForwardRef as ReactComponent };